import { ajax } from "../../../../../plugins/api";

export const helper = {
    presets: {
        list: data => ajax.get("admin/letter-patterns/group", data),
        destroy: id => ajax.delete(`admin/letter-patterns/group/${id}`),
        create: data => ajax.post("admin/letter-patterns/group", data),
        update: (id, data) => ajax.post(`admin/letter-patterns/group/${id}`, data),
        get: id => ajax.get(`admin/letter-patterns/group/${id}`)
    },
    messages: {
        list: data => ajax.get("admin/letter-patterns", data),
        destroy: id => ajax.delete(`admin/letter-patterns/${id}`),
        create: (groupId, data) => ajax.post("admin/letter-patterns", { group_id: groupId, ...data }),
        update: (id, groupId, data) => ajax.post(`admin/letter-patterns/${id}`, { group_id: groupId, ...data }),
        get: id => ajax.get(`admin/letter-patterns/${id}`)
    }
};
